import React, { InputHTMLAttributes } from "react";
import styled from "styled-components";

type StyledTextFieldProps = {
  hasError?: boolean;
};

const StyledTextField = styled.input<StyledTextFieldProps>`
  font-family: opensans-regular;
  color: #333333;
  border-radius: 2px;
  font-size: 1em;
  border: ${p => (p.hasError ? "1px solid #e44404" : "1px solid #d5d5d5")};
  border-top: ${p => (p.hasError ? "1px solid #e44404" : "1px solid #aaaaaa")};
  max-height: 40px;
  padding: 10px 8px;
`;

const HelperText = styled.small`
  color: #e44404;
  font-size: 12px;
  margin-top: 6px;
  line-height: 16px;
  display: block;
  text-align: left;
`;

type TextInputProps = InputHTMLAttributes<any> & {
  hasError?: boolean;
  helperText?: string;
};

const TextField: React.FC<TextInputProps> = props => {
  const { hasError, helperText } = props;

  return (
    <>
      <StyledTextField {...props} />
      {!!hasError && <HelperText>{helperText}</HelperText>}
    </>
  );
};

export default TextField;
